// Whether the dashboard home is showing the first-run wizard. The home page
// sets it once it knows. The product tour and Nova read it, so neither opens
// by itself on top of the wizard.
import { useSyncExternalStore } from "react";

export type FirstRunState = "unknown" | "first-run" | "not-first-run";

let state: FirstRunState = "unknown";
const listeners = new Set<() => void>();

export function setFirstRunState(next: FirstRunState) {
  if (next === state) return;
  state = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useFirstRunState() {
  return useSyncExternalStore(subscribe, () => state);
}
